import request from '@/utils/request';

/*法律援助-申请*/
export function saveAid(json) {
  return request({
    url: '/aid',
    method: 'post',
    data: json,
  })
}

/*法律援助-历史援助列表*/
export function getHistoryAidList(parameter) {
  return request({
    url: '/aid',
    method: 'get',
    params: parameter,
  })
}

/*法律援助-援助详情*/
export function getOneAidDetail(parameter) {
  return request({
    url: '/aid/'+parameter.id,
    method: 'get',
  })
}
